import { CSSObject, IconProps } from '@chakra-ui/react';
import { BottomRowSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/BottomRow/styles/BottomRow.styles';

export const bottomRowStyles: BottomRowSchema = {
  flexWrapper: {
    w: '100%',
  },
  buttonCashOutDesc: {
    w: '100%',
    height: '29px',
    fontWeight: 'normal',
    fontSize: 'sm',
    textTransform: 'capitalize',
    color: 'alpha.900',
    sx: {
      '.cashoutValue': {
        color: 'alpha.900',
      },
      '&:active, &:hover': {
        '.cashoutValue': {
          color: 'alpha.900',
        },
      },
    },
  },
  buttonCashOutAmount: {
    variant: 'primary',
    height: '29px',
    fontFamily: 'Staatliches',
    fontWeight: 'normal',
    _hover: {
      bgGradient: 'linear(180deg, beta.400 0%, beta.500 100%)',
      textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
      color: 'beta.900',
    },
  },
  flexOddsBoostBanner: {
    bg: 'beta.600',
    color: 'alpha.700',
  },
  textOddsBoost: { color: 'white', fontFamily: 'Staatliches' },
  vstackBetsWrapper: {
    w: '100%',
    ml: 'inherit',
  },
  buttonGroupWrapper: {
    w: '100%',
  },
  iconCashOut: {
    fill: 'currentColor',
    pb: '0.5',
  },
  cashoutText: {
    color: 'currentColor',
    pt: '0.5',
  },
  cashoutValue: {
    lineHeight: 'normal',
    pt: '0.5',
  },
  venueRaceWrapper: {
    ml: '26px',
  },
};
export const LinkVenueName: CSSObject = {
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const RaceTime: CSSObject = {
  color: 'alpha.400',
  fontWeight: 'medium',
  alignSelf: 'flex-end',
};

export const BonusBetCheckMark: CSSObject = {
  '&&': {
    display: 'none',
  },
};

export const BonusBetText: CSSObject = {
  color: 'beta.100',
  fontSize: 'xs',
  fontWeight: 'normal',
  textTransform: 'capitalize',
  fontFamily: 'accent',
  bg: 'blackAlpha.600',
  borderRadius: 'md',
  boxShadow:
    '0px 0px 14px 0px rgba(0, 0, 0, 0.5) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
  px: '2',
  pt: '2.5',
  pb: '2',
  lineHeight: 'normal',
};
export const BetReturn: CSSObject = {
  bgGradient: 'linear(to-b, gamma.200, gamma.300)',
  color: 'gray.800',
  borderRadius: 'base',
  fontWeight: 'medium',
  fontSize: '2xs',
};
export const BoxBetReturnValue: CSSObject = {
  py: '0.5',
  p: '1',
  fontWeight: 'bold',
};
export const BoxBetReturnText: CSSObject = {
  my: '1',
  px: '1',
  borderRight: '1px solid',
  borderRightColor: 'beta.800',
};
export const iconLegProps: IconProps = {
  boxSize: '18px',
  border: '2px solid',
  borderColor: 'white',
};
